import Dictionary from "~/ts/library/Dictionary";

export interface AbstractDataProviderActionParamInterface {

}

export const SEARCH_TYPE_VALUE_TYPE_STATIC = "static";
export const SEARCH_TYPE_VALUE_TYPE_FIELD = "field";

export interface SearchTypeInterface {
    enabled: boolean;
    value?: string;
    valueTypeId: typeof SEARCH_TYPE_VALUE_TYPE_STATIC | typeof SEARCH_TYPE_VALUE_TYPE_FIELD;
    fieldId?: string;
}

export interface AbstractDataProviderEntityActionParamInterface extends AbstractDataProviderActionParamInterface {
    searchTypes: Dictionary<SearchTypeInterface>;
}